import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Super Combo después de comprar?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga. El acceso es instantáneo, las 24 horas, todos los días.'
}, {
  q: '¿Sirve para carpinteros sin experiencia previa o solo para profesionales?',
  a: 'Sirve para ambos. El Tomo 1 empieza desde los fundamentos básicos. Los tomos avanzados (4, 5 y 6) tienen contenido de nivel profesional. Cada tomo indica claramente el nivel requerido.'
}, {
  q: '¿Los planos son editables? ¿Puedo modificar las medidas?',
  a: 'Los planos están en PDF con medidas expresadas en milímetros. Son planos de referencia profesional. Podés adaptar las medidas a tu espacio siguiendo los principios de diseño explicados en cada tomo.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos tanto en la oferta de $19.990 ARS como en la de $27.990 ARS. El Sistema Micro-Fábrica es el único adicional de la segunda oferta.'
}, {
  q: '¿Sirve si soy hobbista o solo para carpinteros que venden?',
  a: 'Sirve para ambos. Muchos compradores empezaron como hobbistas y después de implementar los proyectos empezaron a vender. El contenido funciona igual para uso personal o comercial.'
}, {
  q: '¿Los proyectos se pueden fabricar con herramientas básicas (sierra circular y taladro)?',
  a: 'Sí. Cada tomo incluye una sección de herramientas mínimas necesarias. La mayoría de los proyectos se pueden fabricar con sierra circular, taladro, atornillador y nivel de burbuja.'
}, {
  q: '¿Qué hago si no consigo un herraje específico en mi ciudad?',
  a: 'El Bono 2 incluye la tabla completa de sustitutos compatibles para cada herraje. Nunca te vas a quedar sin alternativa.'
}, {
  q: '¿Qué diferencia tiene el Super Combo con otros planos que se consiguen gratis en internet?',
  a: 'Los planos gratuitos generalmente tienen medidas nominales incorrectas, no consideran las holguras de tapacantos, no incluyen lista de herrajes ni protocolos de instalación. El Super Combo incluye medidas reales verificadas, listas de corte con holguras calculadas, protocolos de anclaje y sistema de ventas integrado.'
}, {
  q: '¿Por qué elegir el Super Combo + Sistema Micro-Fábrica y no el estándar?',
  a: 'El Super Combo solo te da los planos y el know-how técnico. El Sistema Micro-Fábrica te da el sistema de producción para fabricarlos 3 veces más rápido y el modelo de negocio para vivir de esto. Si querés más que un hobby, necesitás los dos.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total sin preguntas. Si en 7 días no es lo que esperabas, te devolvemos el 100% de lo pagado. Sin formularios ni drama.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-104">
          <HelpCircle className="w-16 h-16 text-amber mx-auto mb-6" data-id="element-105" />
          <h2 className="text-3xl md:text-5xl font-black text-wood-dark mb-4" data-id="element-106">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-107">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-wood-light/20 rounded-xl overflow-hidden bg-cream-dark" data-id="element-108">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-wood-light/5 transition-colors" data-id="element-109">
                <span className="font-bold text-wood-dark pr-8 text-lg" data-id="element-110">
                  {index + 1} — {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-amber flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-111" />
              </button>
              <AnimatePresence data-id="element-112">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-113">
                    <div className="px-6 pb-5 pt-2 text-charcoal/80 leading-relaxed border-t border-wood-light/10" data-id="element-114">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}